<template>
    <div class="shadow" style="padding: 15px 30px;width:100%">
        <div class="chartStyle " ref="scanActivityByDay"></div>
    </div>
</template>

<script>
import qs from 'qs';

import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

export default {
    data(){
        return {
            chart : null,
            interval: null,
        }
    },
    props : ['filter', 'update'],
    mounted(){
        this.createChart();

    },
    watch : {
        'update' : {
            deep : true,
            handler : 'getData'
        }
    },
    methods:{
        getData(){
            var length = this.chart.data.length;
            console.log('hello');

            this.$http.get(`/api/vehicle/count/map-by-day${qs.stringify(this.filter, {skipNulls:true, addQueryPrefix:true})}`)
            .then((resp)=>{
                console.log(resp);
                var data = resp.data.data;

                for(var i = 0 ; i < data.length ; i++){
                    data[i].date = new Date(data[i].date);
                }

                this.chart.addData(data, length)
            })
            .catch((err)=>{
                console.log(err);
            })
        },
        sampleData(){
            var data = [{
                "date": new Date(2018, 3, 20),
                "value": 65,
                }, {
                "date": new Date(2018, 3, 21),
                "value": 12,
                }, {
                "date": new Date(2018, 3, 22),
                "value": 106,
                }, {
                "date": new Date(2018, 3, 23),
                "value": 75,
                }, {
                "date": new Date(2018, 3, 24),
                "value": 85,
                }, {
                "date": new Date(2018, 3, 25),
                "value": 90,
            }, {
                "date": new Date(2018, 3, 26),
                "value": 90,
            }];

            return data;
        },
        createChart(){
            this.chart = am4core.create( this.$refs.scanActivityByDay , am4charts.XYChart);

            //comment this when developing the API
            // this.chart.data = this.sampleData();

            //create axis x
            let dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());
            dateAxis.title.text = "Date";
            
            //create axis y
            let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
            valueAxis.title.text = "Number of Vehicle";
            valueAxis.min = 0;

            //create first line series
            let lineSeries = this.chart.series.push(new am4charts.LineSeries());
            lineSeries.dataFields.valueY = "count";
            lineSeries.dataFields.dateX = "date";
            lineSeries.name = "Number of Vehicles";
            lineSeries.strokeWidth = 3;

            //add bullet image
            let bullet = lineSeries.bullets.push(new am4charts.CircleBullet());
            bullet.circle.fill = am4core.color("#fff");
            bullet.circle.strokeWidth = 3;
            bullet.tooltipText = "Quantity of Mapped Vehicles in {dateX}: {valueY} ";
            // square.alwaysShowTooltip = true;
            
            //add legend
            this.chart.legend = new am4charts.Legend();
            this.chart.legend.position = "bottom";
            //add cursor
            this.chart.cursor = new am4charts.XYCursor();
        }
    }
}
</script>

<style scoped>
    .chartStyle{
        min-height: 400px;
        /* background-color: white; */
    }
</style>